import React from 'react';
import { View, ScrollView, Text } from 'react-native';
import { Background } from 'LocalGluons';
import { t } from 'Locale';
import { getAppBuildNumber } from 'DeviceUtils';

import { APP_VERSION } from '../../../options';
import defaultStyles from './AppInfo.jss';

const AppInfo = () => (
    <Background>
        <View style={defaultStyles.outerContainer}>
            <ScrollView style={defaultStyles.container}>
                <Text style={defaultStyles.infoItemText}>
                    {`${t('COMMON.VERSION')}: ${APP_VERSION} ${getAppBuildNumber()}`}
                </Text>
            </ScrollView>
        </View>
    </Background>
);

export default AppInfo;
